export default __webpack_public_path__ + "static/media/demac-logo-without-est.4af5a899.png";